<template>
    <div class="product-card__wrapper" :class="{ 'product-card__isSelected': isSelected }" @click="handleClick">
        <div class="product-card__compatibility" v-if="!!compatibilityMessage">
	        <Tippy
		        :content="compatibilityMessage"
		        :allow-html="true"
		        :onShow="onTippyShow"
		        :onHide="onTippyHide"
	        >
		        <FontAwesomeIcon class="icon-tooltip-icon" icon="fa-solid fa-triangle-exclamation"> </FontAwesomeIcon>
	        </Tippy>
        </div>

        <div v-if="imageUrl" class="product-card__img-wrapper">
            <img class="product-card__img" :src="transparentImageUrl" />
        </div>

        <div v-else class="product-card__img-fallback">
            <font-awesome-icon :icon="['fa-thin', 'fa-circle-quarters']" class="product-card__img-fallback-icon" />
        </div>

        <div class="product-card__text-wrapper">
            <p class="product-card__title" :class="{ isSelected: isSelected }">{{ displayName }}</p>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref, onMounted } from 'vue';
import IconTooltip from './shared/IconTooltip.vue';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {Tippy} from "vue-tippy";
const props = defineProps({
    id: String,
    displayName: String,
    description: String,
    imageUrl: String,
    route: String,
    isSelected: Boolean,
    isDisabled: Boolean,
    categoryType: String,
    subcategoryType: String,
    fieldId: String,
    compatibilityMessage: String,
    compatibilityModalMessage: String,
});
const emit = defineEmits(['update-route', 'update-selection']);
const hideOnScrollRef = ref(null);
function handleClick() {
    emit('update-selection', { selection: props, fieldId: props.fieldId });
}

const transparentImageUrl = computed(() => {
    return `${props.imageUrl}&fmt=png-alpha&wid=168`;
});

function onTippyShow(instance) {
	// Define the event listener to hide the tooltip on scroll/wheel
	const hideOnScroll = () => {
		instance.hide()
	}
	hideOnScrollRef.value = hideOnScroll

	// Add event listeners for scroll and wheel events
	window.addEventListener('wheel', hideOnScroll, { passive: true })
	window.addEventListener('scroll', hideOnScroll, { passive: true })
}

function onTippyHide() {
	// Remove the event listeners when the tooltip hides
	if (hideOnScrollRef.value) {
		window.removeEventListener('wheel', hideOnScrollRef.value)
		window.removeEventListener('scroll', hideOnScrollRef.value)
		hideOnScrollRef.value = null
	}
}
</script>
